export default __webpack_public_path__ + "static/kazimierczak-87dc5f2fd0d49fef648d2c68659428ab.jpg";